import {
  RULES_ADD_SUB_GPR,
  RULES_ADD_SUB_ROUNDS,
  RULES_ADD_SUB_START_SECONDS,
} from '../../games/data/vifRulesAddSubData';

import type { RulesAddSubFlag } from './rulesAddSubProblems';
import type { RulesVariantConfig } from './rulesVariantConfig';

/**
 * Per-variant pacing, ported from `VIFRulesAddSub.initGameFlag()` plus the
 * `roundsInModule` / `gamesPerRound` assignment in
 * `rulesBoardEngine.initGame` (lines 199-200).
 */

/** Legacy `intLayersInGame` per flag, from `initGameFlag`'s switch. */
const LAYERS_IN_GAME: Record<RulesAddSubFlag, number> = {
  0: 2,
  1: 2,
  2: 2,
  3: 4,
  4: 4,
  5: 4,
  6: 2,
  7: 2,
  8: 2,
  9: 4,
  10: 4,
  11: 4,
  12: 4,
};

/** Legacy `scaleVar = 2`, set for these flags in `initGameFlag`. */
const LARGE_ANSWERS: ReadonlySet<number> = new Set([2, 4, 5, 8]);

/** Legacy `checkForEndBody`'s `gameFlag == 5 || 11 || 12` branch. */
const ENDS_AFTER_ONE_BOARD: ReadonlySet<number> = new Set([5, 11, 12]);

export function addSubVariantConfig(flag: RulesAddSubFlag): RulesVariantConfig {
  return {
    layersInGame: LAYERS_IN_GAME[flag],
    roundsInModule: RULES_ADD_SUB_ROUNDS[flag]!,
    gamesPerRound: RULES_ADD_SUB_GPR[flag]!,
    startSeconds: RULES_ADD_SUB_START_SECONDS[flag]!,
    large: LARGE_ANSWERS.has(flag),
    endsAfterOneBoard: ENDS_AFTER_ONE_BOARD.has(flag),
    rejectReturnsToStart: false,
    preString: flag === 8 ? 'x = ' : '',
  };
}
